// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_HDW","cls2":"ProfilePdfPackCard-cls2_V_O ProfilePdfPackCard-cls1_HDW"};